import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { Info } from 'lucide-react';
import useMoney from '../../../../../../../hooks/useMoney';
import { useOrderValueVisibility } from '../../../../../../../hooks/useOrderValueVisibility';
import PriceCompositionUtils from '../../../../../../products/prices/utils/priceComposition.utils';
import { OrderItemPriceComposition } from '../../../../../order.types';

interface OrderSummaryCompositionTooltipProps {
  priceComposition: OrderItemPriceComposition;
  isVisible?: boolean;
}

const OrderSummaryCompositionTooltip = ({
  priceComposition,
  isVisible,
}: OrderSummaryCompositionTooltipProps) => {
  const { formatMoney } = useMoney();
  const { shouldHideOrderValues } = useOrderValueVisibility();

  if (!isVisible || shouldHideOrderValues || priceComposition.length === 0) {
    return null;
  }

  const content = (
    <Stack sx={{ gap: 0.5 }}>
      {priceComposition.map((composition) => (
        <Stack
          key={composition.id}
          direction="row"
          sx={{ alignItems: 'baseline', justifyContent: 'space-between', columnGap: 1.5 }}
        >
          <Typography noWrap variant="micro2" color="inherit">
            {PriceCompositionUtils.formatLabel(composition.label)}
          </Typography>
          <Typography noWrap variant="body2" color="inherit">
            {formatMoney(composition.price)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );

  return (
    <Box sx={{ display: 'flex', color: 'inherit' }}>
      <Tooltip placement="top" TooltipContent={content}>
        <Icon icon={Info} size="xs" />
      </Tooltip>
    </Box>
  );
};

export default OrderSummaryCompositionTooltip;
